module.exports = __webpack_public_path__ + "media/Website video.c8dc8121.mp4";